import React, {
    useState,
    useImperativeHandle,
    forwardRef,
} from "react";

export const CanvasAlignmentGuidelinesContainer = forwardRef((props, ref) => {
    const [verticalGuidelines, setVerticalGuidelines] = useState<number[]>([]);
    const [horizontalGuidelines, setHorizontalGuidelines] = useState<number[]>([]);

    // Expose methods to parent via ref
    useImperativeHandle(ref, () => ({
        SetVerticalGuidelines: (coords: number[]) => {
            setVerticalGuidelines(coords);
        },
        SetHorizontalGuidelines: (coords: number[]) => {
            setHorizontalGuidelines(coords);
        },
        ResetGuidelines: () => {
            setVerticalGuidelines([]);
            setHorizontalGuidelines([]);
        }
    }));

    return (
        <div className="canvas-guidelines">
            {verticalGuidelines.map((coord) => (
                <div
                    key={`v-${coord}`}
                    className="canvas-guidelines__vertical-line"
                    style={{ left: `${coord}px` }}
                />
            ))}
            {horizontalGuidelines.map((coord) => (
                <div
                    key={`h-${coord}`}
                    className="canvas-guidelines__horizontal-line"
                    style={{ top: `${coord}px` }}
                />
            ))}
        </div>
    );
});

export default CanvasAlignmentGuidelinesContainer;
